import { render } from "./CBHICard.vue?vue&type=template&id=65a9b6e4&scoped=true"
import script from "./CBHICard.vue?vue&type=script&lang=js"
export * from "./CBHICard.vue?vue&type=script&lang=js"

import "./CBHICard.vue?vue&type=style&index=0&id=65a9b6e4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a9b6e4"]])

export default __exports__